import React from 'react';

import { Alert, AlertHeading, AlertMessage } from '@components/common';
import { useAccount } from '@hooks/useAccount';

type AdminApprovalRequestedProps = {
  approvalRequest: ApprovalRequest;
};

export const AdminApprovalRequested: React.FC<AdminApprovalRequestedProps> = ({ approvalRequest }) => {
  const {
    account: { team }
  } = useAccount();

  const getName = (id: number) => team.find((user) => user.id === id)?.name;
  const creatorName = getName(approvalRequest.creator_id);

  return (
    <Alert className='my-4' type='warning'>
      <>
        <AlertHeading>Study approval requested</AlertHeading>
        <AlertMessage>
          {creatorName} requested you review this study. Please approve or reject the study to proceed.
        </AlertMessage>
      </>
    </Alert>
  );
};
